import {
    useSelector } from "react-redux";
import SnpButton from "../global/SnpButton";
import { useEffect,
    useState } from "react";
import {
  getAuthSession,
  getPreUrlAccordingToCart,
  GETSINGLECONFIGS,
  isEmpty,
  printDebugLog,
  RANGE_DELIVERYCHARGE,
  SUCCESS
} from "../../constants/constant";
import useUiController from "../global/hooks/useUiController";
import SnpBaseLayout from "../global/SnpBaseLayout";
import CustomDataGrid from "../global/CustomDataGrid";
import { Grid, Paper, TextField } from "../ui";
import { snpAxios } from "../global/api";
import axios from "axios";
import { useNavigate } from "react-router-dom";


const MinimumOrderDistance = () => {

    const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
    const navigate = useNavigate();

    const INITIAL_DELIVERY_RANGE = {
        id: "",
        minKm: 0.0,
        maxKm: 0.0,
        deliveryCharge: 0.0,
        minOrderAmount: 0.0,
    }

    const columns = [
        { field: 'minKm', headerName: 'Min km', width: 150 },
        { field: 'maxKm', headerName: 'Max km', width: 150 },
        { field: 'deliveryCharge', headerName: 'Delivery Charge', width: 200 },
        { field: 'minOrderAmount', headerName: 'Min. Order Amount', width: 200 },
        {
            field: "edit",
            headerName: "",
            width: 90,
            renderCell: (cellValues) => {
                return (
                    <SnpButton variant="contained"
                        mbgcolor="#538796"
                        mpadding="1px"
                        onPointerDown={()=>handleCellClick(cellValues.row)}
                    >Edit</SnpButton>
                );
            }
        },
        {
            field: "Del",
            headerName: "",
            width: 90,
            renderCell: (cellValues) => {
                return (
                    <SnpButton variant="contained"
                        mbgcolor="#e91b21"
                        mpadding="1px"
                        onPointerDown={() => handleDelClick(cellValues.row)}
                    >Del</SnpButton>
                );
            }
        }
    ];

    const {
        loader,
        setLoader,
        snackbarConfig,
        showSnackbar,
        closeSnackbar,
        dialogConfig,
        showDialog,
        closeDialog,
    } = useUiController();

    const [shopDeliveryRange, setShopDeliveryRange] = useState(INITIAL_DELIVERY_RANGE);
    const [rangeList, setRangeList] = useState([]);

    useEffect(() => {
        getSingleConfigs(RANGE_DELIVERYCHARGE);
    }, [storeApiUrl,storeActiveShopHash]);

    const getSingleConfigs = async (mConfigName) => {
        try {
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}${GETSINGLECONFIGS}?adminId=${getAuthSession().apiToken}&configName=${mConfigName}&shopHash=${storeActiveShopHash.id}`;
            const response = await axios.get(cUrl);
            printDebugLog(`getSingleConfigs:${mConfigName}`, response);
            if (response.data !== '') {
                if (mConfigName === RANGE_DELIVERYCHARGE) {
                    const allowed = response.data === 'Yes';
                    if (allowed) {
                        getShopDeliveryRange();
                    } else {
                        showDialog({
                            ...dialogConfig,
                            negativeReq: true,
                            positiveReq: false,
                            negativeAction: "Ok!", 
                            subTitle: "You don't have permission to access. Contact Owner",
                            handleClose: () => {
                                closeDialog();
                                navigate("/dashboard/billhandler");
                            },
                        });
                    }
                }
            }
        } catch (e) {
            console.error("getSingleConfigs:error", e);
        }
    };


    const getShopDeliveryRange = async () => {
        try {
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-shop-delivery-charge-range?s=${storeActiveShopHash.id}`;
            setLoader(true);
            const response = await snpAxios.get(cUrl);
            printDebugLog("getShopDeliveryRange", response.data);
            if (response.data.status === SUCCESS) {
                setRangeList(response.data.jcJson.fullData);
            }
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.error("getShopDeliveryRange ", error);
        }
    };

    const deleteShopDeliveryRange = async (id) => {
        try {
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}delete-shop-delivery-charge-range?t=${getAuthSession().apiToken}&s=${storeActiveShopHash.id}&id=${id}`;
            setLoader(true);
            const response = await snpAxios.get(cUrl);
            printDebugLog("deleteShopDeliveryRange", response.data);
            if (response.data.status === SUCCESS) {
                setShopDeliveryRange(INITIAL_DELIVERY_RANGE);
                fireSnackBarMsg({ msg: "Deleted Successfully" });
                getShopDeliveryRange();
            }
        } catch (error) {
            setLoader(false);
            console.error("deleteShopDeliveryRange ", error);
        }
    };

    const updateShopDeliveryRange = async () => {
        try {
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}save-shop-delivery-charge-range`;
            setLoader(true);
            const data = {
                jcJson: {
                    apiToken:getAuthSession().apiToken,
                    shopHash:storeActiveShopHash.id,
                    ...shopDeliveryRange,
                }
            }
            const response = await snpAxios.post(cUrl,data);
            printDebugLog("updateShopDeliveryRange", response.data);
            if (response.data.status === SUCCESS) {
                setShopDeliveryRange(INITIAL_DELIVERY_RANGE);
                fireSnackBarMsg({ msg: "Updated Successfully" });
                getShopDeliveryRange();
            } else {
                fireSnackBarMsg({ msg: "Failed to update" , mColor: "#f44336" });
            }
        } catch (error) {
            setLoader(false);
            fireSnackBarMsg({ msg: "Failed to update" , mColor: "#f44336" });
            console.error("updateShopDeliveryRange ", error);
        }
    };

    const handleCellClick = (row) => {
        printDebugLog("handleCellClick", row);
        setShopDeliveryRange(prev => ({
            ...prev,
            ...row,
        }));
    };

    const handleDelClick = (row) => {
        printDebugLog("handleDelClick", row);
        deleteShopDeliveryRange(row.id);
    };

    const fireSnackBarMsg = ({ msg, mColor = "#008b8b", mHorizontal = "right", mVertical = "top" }) => {
        showSnackbar(msg, mColor, mVertical, mHorizontal);
    };

    return (
        <SnpBaseLayout
            loader={loader}
            dialogConfig={dialogConfig}
            snackbarConfig={{ ...snackbarConfig, onClose: closeSnackbar }}
        >
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Paper elevation={10}
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            backgroundColor: "#e9d9d696",
                            boxShadow: 1,
                            borderRadius: 4,
                            padding: 1,
                            maxHeight: 230,
                            height: 230,
                        }} >
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={4} sm={6} lg={4}>
                                <TextField
                                    id="minKm"
                                    name="minKm"
                                    variant="filled"
                                    size="small"
                                    label="Enter Minimum Km"
                                    value={shopDeliveryRange.minKm}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === '' || /^\d*\.?\d*$/.test(value)) {
                                            setShopDeliveryRange(prev => ({
                                                ...prev,
                                                minKm: value,
                                            }));
                                        }
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={4} sm={6} lg={4}>
                                <TextField
                                    id="maxKm"
                                    name="maxKm"
                                    variant="filled"
                                    size="small"
                                    label="Enter Maximum Km"
                                    value={shopDeliveryRange.maxKm}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === '' || /^\d*\.?\d*$/.test(value)) {                                            
                                            setShopDeliveryRange(prev => ({
                                                ...prev,
                                                maxKm: value,
                                            }));
                                        }
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={4} sm={6} lg={4}>
                                <TextField
                                    id="deliveryCharge"
                                    name="deliveryCharge"
                                    variant="filled"
                                    size="small"
                                    label="Enter Delivery Charge"
                                    value={shopDeliveryRange.deliveryCharge}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === '' || /^\d*\.?\d*$/.test(value)) {
                                            setShopDeliveryRange(prev => ({
                                                ...prev,
                                                deliveryCharge: value,
                                            }));
                                        }
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={4} sm={6} lg={4}>
                                <TextField
                                    id="minOrderAmount"
                                    name="minOrderAmount"
                                    variant="filled"
                                    size="small"
                                    label="Enter Min. Order Amount"
                                    value={shopDeliveryRange.minOrderAmount}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === '' || /^\d*\.?\d*$/.test(value)) {
                                            setShopDeliveryRange(prev => ({
                                                ...prev,
                                                minOrderAmount: value,
                                            }));
                                        }
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={6} md={2} sm={4} lg={2}>
                                <SnpButton variant="contained"
                                    mbgcolor={!isEmpty(shopDeliveryRange.id) ? "#e1a42b" : "#538796"}
                                    mpadding="1px"
                                    onPointerDown={()=>updateShopDeliveryRange()}
                                >{isEmpty(shopDeliveryRange.id) ? "Add" : "Update"}</SnpButton>
                            </Grid>
                            {
                                !isEmpty(shopDeliveryRange.id)
                                && <Grid item xs={6} md={2} sm={4} lg={2}>
                                    <SnpButton variant="contained"
                                        mbgcolor="#e91b21"
                                        mpadding="1px"
                                        onPointerDown={()=> deleteShopDeliveryRange(shopDeliveryRange.id)}
                                    >Delete</SnpButton>
                                </Grid>
                            }
                        </Grid>
                        </Paper>
                </Grid>
                <Grid item xs={12}>
                    <CustomDataGrid
                        getRowId={row => row.id}
                        rows={rangeList}
                        columns={columns}
                    />
                </Grid>
            </Grid>
        </SnpBaseLayout>
    );
};

export default MinimumOrderDistance;